import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { ResourceBadge } from '@/components/ui/resource-badge';
import { OrderDetail } from '@/lib/api/orders';
import { OrderResourceBadge } from '@/components/orders/OrderResourceBadge';

interface OrderRelatedCardProps {
  order: OrderDetail;
}

export function OrderRelatedCard({ order }: OrderRelatedCardProps) {
  const { t } = useTranslation('orders');

  const hasParent = !!(order as any).parentOrderId;
  const hasRefunds = (order as any).refundOrderIds && (order as any).refundOrderIds.length > 0;

  if (!hasParent && !hasRefunds) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('relatedOrders')}</CardTitle>
        <CardDescription>{t('linkedOrders')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Parent Order */}
          {hasParent && (
            <div>
              <span className="text-muted-foreground text-sm">{t('parentOrder')}</span>
              <div className="mt-2 flex items-center rounded-lg border p-3">
                <OrderResourceBadge
                  orderId={(order as any).parentOrderId!}
                  variant="outline"
                />
              </div>
            </div>
          )}

          {hasParent && hasRefunds && <Separator />}

          {/* Refund Orders */}
          {hasRefunds && (
            <div>
              <span className="text-muted-foreground text-sm">
                {t('refundOrders')} ({(order as any).refundOrderIds!.length})
              </span>
              <div className="mt-2 space-y-2">
                {(order as any).refundOrderIds!.map((refundOrderId: string) => (
                  <div key={refundOrderId} className="flex items-center rounded-lg border p-3">
                    <OrderResourceBadge
                      orderId={refundOrderId}
                      variant="outline"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
